/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticleDisclosureLabel/theme';

export const ArticleDisclosureLabelTheme = theme;
